import React from "react"
import { StyleSheet, View } from "react-native"
import { Text } from "../atoms"
import { useTheme } from '@react-navigation/native'
import { Theme } from '@theme'


export const NotifBadge = ({total, testID}: {total: number; testID?: string}) => {
    const theme = useTheme()
    const styles = getStyle(theme)

    return !total? null : (
        <View testID={testID} style={styles.filterBadge}>
            <Text 
                type="bodySmall" 
                color={theme.colors.white}
                style={styles.filterBadgeText}
            >
                {total}
            </Text>
        </View>
    )
}

const getStyle = (theme: Theme) =>
    StyleSheet.create({
      // Small corner badge: sits on the top-right corner of the host icon
      // without covering it. A white ring separates it from the icon below.
      filterBadge: {
        position: 'absolute',
        top: -6,
        right: -8,
        backgroundColor: theme.colors.error,
        borderRadius: 8,
        minWidth: 16,
        height: 16,
        justifyContent: 'center',
        alignItems: 'center',
        paddingHorizontal: theme.spacing.xxs,
        borderWidth: 1.5,
        borderColor: theme.colors.white,
      },
      filterBadgeText: {
        fontSize: 9,
        lineHeight: 12,
        fontWeight: 'bold',
      },
    })